/**
 * @generated SignedSource<<8d8f063dfef5f54e0c57328dc4a12a3b>>
 * @relayHash 0aa077f933d74140c001bec3d467e720
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c6373d22d123fa5f7b5438f631927fd14cdd17f6a68146384714c08dad57b7e1

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type L1MenuItemsQuery$variables = {
  cloudId: string;
  isAppsExpanded?: boolean | null | undefined;
  isDashboardsExpanded?: boolean | null | undefined;
  isFiltersExpanded?: boolean | null | undefined;
  isPlansExpanded?: boolean | null | undefined;
  isProjectsExpanded?: boolean | null | undefined;
};
export type L1MenuItemsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurableMenu">;
};
export type L1MenuItemsQuery = {
  response: L1MenuItemsQuery$data;
  variables: L1MenuItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "isAppsExpanded"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "isDashboardsExpanded"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "isFiltersExpanded"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "isPlansExpanded"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "isProjectsExpanded"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "label"
},
v6 = {
  "kind": "ScalarField",
  "name": "url"
},
v7 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v8 = {
  "order": "DESC"
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v10 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v13 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v14 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EDIT_PROJECT_CONFIG"
  }
],
v15 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
],
v16 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v1/*: any*/),
          {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "small"
              }
            ]
          },
          (v11/*: any*/),
          {
            "kind": "ScalarField",
            "name": "projectType"
          },
          {
            "kind": "LinkedField",
            "name": "jwmDefaultSavedView",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "typeKey"
                  }
                ],
                "type": "JiraWorkManagementSavedView"
              },
              (v12/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "navigationMetadata",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "boardId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isSimpleBoard"
                  },
                  (v1/*: any*/)
                ],
                "type": "JiraSoftwareProjectNavigationMetadata"
              }
            ]
          },
          (v13/*: any*/),
          {
            "kind": "ScalarField",
            "name": "projectStyle"
          },
          {
            "kind": "ScalarField",
            "name": "projectTypeName"
          },
          {
            "kind": "ScalarField",
            "name": "webUrl"
          },
          {
            "alias": "editPermission",
            "args": (v14/*: any*/),
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "args": (v14/*: any*/),
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
          },
          {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
          }
        ],
        "type": "JiraProject"
      },
      (v12/*: any*/)
    ]
  }
],
v17 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v18 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v19 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v20 = {
  "kind": "ScalarField",
  "name": "jql"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v1/*: any*/)
      ]
    }
  ],
  "type": "JiraCustomFilter"
},
v22 = {
  "kind": "ScalarField",
  "name": "title"
},
v23 = {
  "concreteType": "JiraFavouriteValue",
  "kind": "LinkedField",
  "name": "favouriteValue",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v1/*: any*/)
  ]
},
v24 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "planId"
          },
          (v22/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isReadOnly"
          },
          {
            "kind": "ScalarField",
            "name": "planStatus"
          },
          (v23/*: any*/),
          {
            "concreteType": "JiraScenario",
            "kind": "LinkedField",
            "name": "scenario",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "scenarioId"
              },
              (v1/*: any*/)
            ]
          }
        ],
        "type": "JiraPlan"
      },
      (v12/*: any*/)
    ]
  }
],
v25 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "dashboardId"
          },
          (v22/*: any*/),
          (v23/*: any*/)
        ],
        "type": "JiraDashboard"
      },
      (v12/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ConfigurableMenu"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudID",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "navKey",
                "value": "NAV_SIDEBAR"
              }
            ],
            "concreteType": "JiraUserNavigationConfiguration",
            "kind": "LinkedField",
            "name": "userNavigationConfiguration",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraConfigurableNavigationItem",
                "kind": "LinkedField",
                "name": "navItems",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "menuId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isVisible"
                  }
                ]
              },
              (v1/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "canCreateProject",
            "args": [
              (v2/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "CREATE_PROJECT"
              }
            ],
            "kind": "ScalarField",
            "name": "canPerform"
          },
          {
            "condition": "isAppsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraNavigationItemConnection",
                "kind": "LinkedField",
                "name": "globalAppNavigationItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNavigationItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v1/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "appType"
                              },
                              (v6/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "iconUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "settingsUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "envLabel"
                              },
                              (v7/*: any*/),
                              {
                                "concreteType": "JiraAppSection",
                                "kind": "LinkedField",
                                "name": "sections",
                                "plural": true,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v6/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraAppNavigationItem"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isProjectsExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "favouriteProjects",
                "args": [
                  (v2/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": (v8/*: any*/),
                      "type": "PROJECT"
                    }
                  },
                  (v9/*: any*/)
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v16/*: any*/)
                  },
                  (v17/*: any*/)
                ]
              },
              {
                "alias": "recentProjects",
                "args": [
                  (v2/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "PROJECT"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v16/*: any*/)
                  },
                  (v17/*: any*/)
                ]
              },
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraWorkManagementLicensing",
                "kind": "LinkedField",
                "name": "jwmLicensing",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "currentUserSeatEdition"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isFiltersExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "favouriteFilters",
                "args": [
                  (v2/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": (v8/*: any*/),
                      "type": "FILTER"
                    }
                  },
                  (v9/*: any*/)
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v19/*: any*/),
                              (v11/*: any*/),
                              (v1/*: any*/),
                              (v13/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/)
                            ],
                            "type": "JiraFilter",
                            "abstractKey": "__isJiraFilter"
                          },
                          (v12/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v17/*: any*/)
                ]
              },
              {
                "alias": "recentFilters",
                "args": [
                  (v2/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "FILTER"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v19/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v1/*: any*/),
                                  (v13/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/)
                                ],
                                "type": "JiraFilter",
                                "abstractKey": "__isJiraFilter"
                              }
                            ],
                            "type": "JiraCustomFilter"
                          },
                          (v12/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isPlansExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "favouritePlans",
                "args": [
                  (v2/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "type": "PLAN"
                    }
                  },
                  (v9/*: any*/)
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v24/*: any*/)
                  },
                  (v17/*: any*/)
                ]
              },
              {
                "alias": "recentPlans",
                "args": [
                  (v2/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "PLAN"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v24/*: any*/)
                  },
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isDashboardsExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "dashboardFavourites",
                "args": [
                  (v2/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": (v8/*: any*/),
                      "type": "DASHBOARD"
                    }
                  },
                  (v9/*: any*/)
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v25/*: any*/)
                  },
                  (v17/*: any*/)
                ]
              },
              {
                "alias": "dashboardRecents",
                "args": [
                  (v2/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "DASHBOARD"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v25/*: any*/)
                  },
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c6373d22d123fa5f7b5438f631927fd14cdd17f6a68146384714c08dad57b7e1",
    "metadata": {},
    "name": "L1MenuItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "43a7f51a19c0e98a3c9660ec9aac8ecf";

export default node;
